import { applyCost, canAffordCost } from '../map/settlement';
import type { ModalActionHandler } from './modalActionTypes';
import { getSettlement } from './settlementActionUtils';
import { scaleCost } from '../economy/costScaling';
import { queueConstruction } from '../economy/construction';
import { canQueueBuilding } from '../economy/settlementLimits';

export const buildStoneHouseAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement) return false;
    if (!canQueueBuilding(settlement, 'stoneHouse')) return false;
    const cost = scaleCost(
        state.config.buildings.stoneHouse.cost || {},
        settlement.buildings.stoneHouse + 1,
        state.config.buildings.stoneHouse.costScaling || { a: 0, b: 0 },
    );
    if (!canAffordCost(settlement, cost)) return false;
    applyCost(settlement, cost);
    queueConstruction(settlement, 'stoneHouse', state.simulation.tick, cost);
    return true;
};
